var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "buyNowButton", staticClass: "buyNowButtonMain" },
    [
      _c("BuyNow", {
        attrs: { ifShow: _vm.ifShowBuyNowDialog, shopInfo: _vm.buyNowShopInfo },
        on: {
          "update:ifShow": function($event) {
            _vm.ifShowBuyNowDialog = $event
          },
          "update:if-show": function($event) {
            _vm.ifShowBuyNowDialog = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          style: "opacity: " + (_vm.keepPress ? 1 : 0.6),
          on: { click: _vm.buyNow }
        },
        [_vm._v("现场买单")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }